package one.healthium.today.ui.fodmap

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.unit.dp
import one.healthium.healthKit.ui.HealthKitConnectBanner
import one.healthium.healthKit.ui.HealthKitConnectBannerContract
import one.healthium.tasks.domain.DailyTaskModel
import one.healthium.tasks.domain.DailyTaskType
import one.healthium.tasks.ui.dailyTaskListItems
import one.healthium.ui.compose.components.AppScaffold
import org.koin.compose.viewmodel.koinViewModel

interface TodayEventDelegate {
    fun onLogWeightTaskClicked(taskId: String)
    fun onLogWaterTaskClicked(taskId: String)
    fun onLogFoodTaskClicked(taskId: String)
    fun onReadInsightTaskClicked(insightId: String)
    fun onDoWorkoutTaskClicked(workoutId: String)
    fun onLogSymptomsTaskClicked(taskId: String)
}

@Composable
fun TodayScreen(eventDelegate: TodayEventDelegate) {
    val viewModel = koinViewModel<TodayViewModel>()
    val state by viewModel.state.collectAsState()

    TodayScreenContent(
        state = state,
        onTaskClicked = { task ->
            when (val dailyTaskType = task.info.type) {
                DailyTaskType.LogWeight -> eventDelegate.onLogWeightTaskClicked(task.id)
                DailyTaskType.LogWater -> eventDelegate.onLogWaterTaskClicked(task.id)
                DailyTaskType.LogFood -> eventDelegate.onLogFoodTaskClicked(task.id)
                is DailyTaskType.ReadInsight -> eventDelegate.onReadInsightTaskClicked(dailyTaskType.id)
                is DailyTaskType.DoWorkout -> eventDelegate.onDoWorkoutTaskClicked(dailyTaskType.id)
                DailyTaskType.LogSymptoms -> eventDelegate.onLogSymptomsTaskClicked(task.id)
            }
        },
        healthKitContract = viewModel,
    )
}

@Composable
private fun TodayScreenContent(
    state: TodayUiState,
    onTaskClicked: (DailyTaskModel) -> Unit,
    healthKitContract: HealthKitConnectBannerContract,
) {
    AppScaffold(Modifier.testTag("today_screen")) {
        LazyColumn(
            contentPadding = PaddingValues(bottom = 90.dp)
        ) {
            item {
                TodayCalendar(state.todayCalendarUiModel)
            }
            if (state.shouldShowHKBanner) {
                item {
                    Spacer(Modifier.height(24.dp))
                    HealthKitConnectBanner(contract = healthKitContract)
                }
            }
            dailyTaskListItems(
                uiModel = state.tasksUiModel,
                contentPadding = PaddingValues(horizontal = 12.dp),
                onTaskClicked = onTaskClicked,
            )
        }
    }
}
